// extracted by mini-css-extract-plugin
export default {"Box_0":"BlankState-module__Box_0--A2T3t","Box_1":"BlankState-module__Box_1--RFnfO","Box_2":"BlankState-module__Box_2--DdKMe","Box_3":"BlankState-module__Box_3--iGsRg"};